"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(".o-home-blog__grid");
        if (!initSlider) return;

        new Swiper(".o-home-blog__grid", {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            navigation: {
                nextEl: ".o-home-blog__arrow--next",
                prevEl: ".o-home-blog__arrow--prev",
            },
            breakpoints: {
                680: {
                    slidesPerView: 2,
                },
                1280: {
                    loop: false,
                    slidesPerView: 3,
                    spaceBetween: 149,
                },
            },
        });
    });
}
